import { connect } from 'react-redux'
import AssemblyDialog from '../../../components/FilesCourse/newCommande/AssemblyDialog'
import { downloadFiles } from '../../../redux/shipment/actions'
import { getIsLoadingFiles } from '../../../redux/shipment/selectors'

const mapStateToProps = (state) => ({
  isLoadingFiles: getIsLoadingFiles(state),
})
const mapDisptachToProps = (dispatch) => ({
  downloadFiles: (fileDetail) => dispatch(downloadFiles(fileDetail)),
})

export default connect(mapStateToProps, mapDisptachToProps)(AssemblyDialog)
